import { createRouter, createWebHistory } from 'vue-router';
// MIGRAÇÃO: stack migrada para Rust + Svelte em gateway.vr.app.br
// As rotas de login abaixo estão desativadas — o redirect abaixo assume o controle.
// Em caso de problemas, remova o beforeEach e descomente os imports/rotas originais.
//
// import LoginView from '../views/LoginView.vue';
import MaintenanceView from '../views/MaintenanceView.vue';
import PasswordForgotView from '../views/PasswordForgot.vue';
import PasswordResetView from '../views/PasswordReset.vue';

const NEW_GATEWAY_URL = 'https://gateway.vr.app.br';

const routes = [
  // ROTA ORIGINAL — desativada após migração para gateway.vr.app.br
  // {
  //   path: '/',
  //   name: 'login',
  //   component: LoginView,
  // },
  {
    path: '/maintenance',
    name: 'maintance',
    component: MaintenanceView,
  },
  {
    path: '/password/forgot',
    name: 'password-forgot',
    meta: {
      title: 'Redefinir senha',
    },
    component: PasswordForgotView,
  },
  {
    path: '/password/reset/:key/:token',
    name: 'password-reset',
    meta: {
      title: 'Redefinir senha',
    },
    component: PasswordResetView,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// REDIRECT DE MIGRAÇÃO: home e login agora apontam para a nova stack
// Para reverter: remova este beforeEach e descomente a rota '/' acima.
router.beforeEach((to) => {
  if (to.path === '/' || to.name === 'login') {
    window.location.href = NEW_GATEWAY_URL;
    return false;
  }
  return true;
});

export default router;
